import { createSlice } from '@reduxjs/toolkit'
import { ProgramWorkingHoursState } from '../types/programWorkingHours.types'

const initialState: ProgramWorkingHoursState = {
  content: null,
  selected: null,
  totalPages: null,
  programId : null,
  pageSize : null,
  pageNumber : null,
}

const programWorkingHoursSlice = createSlice({
  name: 'programWorkingHours',
  initialState,
  reducers: {
    updateProgramWorkingHours: (state, action) => {
      state.pageNumber = action.payload.number;
      state.pageSize = action.payload.size;
      state.totalPages = action.payload.totalPages;
      state.content = action?.payload.content;
    },
    updateSelectedProgramWorkingHours: (state, action) => {
      state.selected = action.payload
    },
    updateCreateProgramWorkingHours: (state, action) => {
        state.programId = action.payload.id
    },
    resetProgramWorkingHours: (state) => {
      state.content = null
    },
    
    //actions
    getAllProgramWorkingHoursAction: () => {
      return
    },
    createProgramWorkingHoursAction: (state, action) =>
      {
        state.programId = action.payload.id
      },
      getSingleProgramWorkingHoursAction: (state, action) => {
        state.programId = action.payload.id
      },
      updateProgramWorkingHoursAction: (state, action) => {
        state.programId = action.payload.id
      },
      deleteSelectedProgramWorkingHours:() =>
      {
        return;
      }
    },
})

export const {
  updateSelectedProgramWorkingHours,
  updateProgramWorkingHours,
  resetProgramWorkingHours,
  getAllProgramWorkingHoursAction,
  updateCreateProgramWorkingHours,
  getSingleProgramWorkingHoursAction,
  updateProgramWorkingHoursAction,
  createProgramWorkingHoursAction,
  deleteSelectedProgramWorkingHours,
} = programWorkingHoursSlice.actions

export default programWorkingHoursSlice.reducer